// extracted by mini-css-extract-plugin
module.exports = {"loader":"OutsideClickHandler_loader__PcD7l","root":"OutsideClickHandler_root__tyjJ9"};